export const faqs = [
  {
    q: 'Do I need design experience to customize Solvora?',
    a: 'No. Every visual choice is controlled by a small set of shared tokens — color, type, spacing — so changing your brand is a matter of editing values, not rebuilding layouts.',
  },
  {
    q: 'Can I use Solvora for a mobile app landing page?',
    a: 'Yes. The device mockup components support both browser and phone frames, and the layout system adapts down to small screens by default.',
  },
  {
    q: 'Is the Insights blog connected to a CMS?',
    a: 'Insights reads from Firestore when it is configured, and falls back to local seed content otherwise, so the blog works immediately and scales into a full CMS later.',
  },
  {
    q: 'What happens after someone submits the contact form?',
    a: 'Submissions are written to Firestore and the visitor is redirected to a dedicated Success page confirming their message was received.',
  },
  {
    q: 'Can I change the accent color without editing every component?',
    a: 'Yes — accent, surface, and text colors are defined once as CSS custom properties in variables.css and referenced everywhere else.',
  },
];
